import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

export interface DialogData {
  title: string;
  content: string;
  saveButtonLabel: string;
  cancelButtonLabel: string;
  rightButtonText: string;
  leftButtonText: string;
  displayEmailInput: boolean;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  formGroup!: FormGroup;
  displayEmailInput: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogComponent>,
    private formBuilder: FormBuilder
  ) {

    this.displayEmailInput = this.data.displayEmailInput;
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup = this.formBuilder.group({
      email: [''],
    });
  }

  onRightButton() {
    if (this.displayEmailInput) {
      this.dialogRef.close(
        {
          send: true,
          email: this.formGroup.get('email')?.value,
        }
      );
    } else {
      this.dialogRef.close(true);
    }

  }

  onCancel() {
    if (this.displayEmailInput) {
      this.dialogRef.close(
        {
          send: false,
        }
      );
    } else {
      this.dialogRef.close(false);
    }
  }
}
